import EventBus from '@/eventBus'

const MESSAGE_TYPES = {
  CHANGE_VOTING_STEP: 'change-voting-step',
  CREATE_IDEA: 'create-idea',
  VOTE_IDEA: 'vote-idea',
  REMOVE_IDEA: 'remove-idea',
}

function handleChangeVotingStep(doc, rootComponent) {
  const slide = rootComponent.$store.getters.activeActivity
  if (!rootComponent.presentation.audiencePacing) {
    slide.votingStep = doc.data.votingStep
    rootComponent.$store.dispatch('updateSlide', rootComponent.$store.getters.activeActivity)
    EventBus.$emit('update-voting-step', doc.data.votingStep)
    if (doc.data.votingStep === 'result') {
      document.body.scrollIntoView()
    }
  }
}

function handleCreateIdea(doc, rootComponent) {
  const slide = rootComponent.$store.getters.activeActivity
  slide.ideasCount = doc.data.ideasCount
  EventBus.$emit('create-idea', doc.data)
  rootComponent.$store.dispatch('updateSlide', rootComponent.$store.getters.activeActivity)
}

function handleVoteIdea(doc) {
  EventBus.$emit('vote-idea', doc.data)
}

function handleRemoveIdea(doc) {
  EventBus.$emit('remove-idea', doc.data)
}

const BrainStormWebSocketSubscriber = {
  [MESSAGE_TYPES.CHANGE_VOTING_STEP]: handleChangeVotingStep,
  [MESSAGE_TYPES.CREATE_IDEA]: handleCreateIdea,
  [MESSAGE_TYPES.VOTE_IDEA]: handleVoteIdea,
  [MESSAGE_TYPES.REMOVE_IDEA]: handleRemoveIdea,
}

export default BrainStormWebSocketSubscriber
